import CelebrateALife from "@/components/site/CelebrateALife";
import CelebrateALifeArticle from "@/components/site/CelebrateALifeArticle";
import { motion } from "framer-motion";

export default function CelebrateALifePage() {
  return (
    <main data-testid="celebrate-page">
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-6 text-center">
        <div className="overline mb-4">Chapter · Remembrance</div>
        <motion.h1
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="heritage-title text-4xl md:text-6xl lg:text-7xl leading-[1.02] tracking-[-0.01em]"
        >
          Celebrate a Life —
          <br />
          <span className="italic font-italic-serif text-[color:var(--rust)]">Memorials</span>
        </motion.h1>
        <p className="mt-6 max-w-2xl mx-auto font-italic-serif italic text-lg text-[color:var(--ink-soft)]">
          "A candle lit in memory is a page kept open. Here we hold the names of those
          who shaped us — respectfully, permanently, together."
        </p>
      </section>

      <CelebrateALife compact={false} />
      <CelebrateALifeArticle />
    </main>
  );
}
